module.exports = __webpack_public_path__ + "assets/img/10-1.50fcb1e5.png";